// import React, { Component } from "react";
// import { Modal } from "react-bootstrap";
// import styled from "styled-components";
// import socket from "../../../Socket";
// import storage from "../../../Storage";
// import {
//   decode,
//   encode,
//   getElement,
//   sendNotfication,
//   isEmail,
//   Event,
//   DEVELOPMENT,
//   wait,
//   randomString,
// } from "../../../Helper";
// import C from "../../../Constant";
// import axios from "axios";

// const StyledModal = styled(Modal)`
//   .modal-content {
//     background-color: rgb(35 38 38);
//     color: white;
//     border-radius: 18px;
//     overflow: hidden;
//     display: flex;
//     flex-direction: row;

//     @media (max-width: 340px) {
//       margin: 5px !important;
//     }
//   }
//   .modal-md {
//     @media (min-width: 640px) {
//       max-width: 50rem !important;
//     }
//   }
// `;

// const ModalHeader = styled.div`
//   background-color transparent;
//   // padding: 10px;
//   padding-left:15px;
//   padding-right:15px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;

// const CloseButton = styled.button`
//   background: none;
//   border: none;
//   color: white;
//   font-size: 24px;
//   cursor: pointer;
//   display: flex;
//   justify-content: flex-end;

//   @media (max-width: 640px) {
//     display: none;
//   }
// `;

// const ModalBody = styled(Modal.Body)`
//   @media (max-width: 400px) {
//     padding: 0px;
//     padding-top: 10px;
//   }
// `;

// const StyledForm = styled.form`
//   display: flex;
//   flex-direction: column;
//   gap: 15px;
// `;

// const StyledInput = styled.input`
//   background-color: #1e2121;
//   border: 1px solid #3a4142;
//   border-radius: 7px;
//   color: white;
//   padding: 7px;
//   font-size: clamp(5px, 3vw, 12px);
//   &::placeholder {
//     color: #9ca3af;
//     font-weight: 500;
//   }
//   &:focus {
//     outline: none;
//     border-color: rgb(204, 120, 0);
//     box-shadow: 0 0 0 0.5px rgb(204, 120, 0);
//   }
// `;

// const Labeltext = styled.div`
//   color: #696f79;
//   font-size: 14px;
// `;

// const ButtonContainer = styled.div`
//   display: flex;
//   gap: 10px;
//   justify-content: center;
// `;

// const Button = styled.button`
//   padding: 10px 20px;
//   border-radius: 7px;
//   font-weight: bold;
//   cursor: pointer;
//   transition: all 0.3s ease;
// `;

// const SignUpButton = styled(Button)`
//   background-image: linear-gradient(90deg, rgb(255, 215, 0), rgb(255, 140, 0));
//   box-shadow: rgb(255, 168, 0) 0px -2px inset;
//   color: black;
//   border: none;
//   width: 100%;
//   max-width: 100%;
//   max-height: 100%;
//   margin-top: 10px;

//   &:hover {
//     background-color: #7c3aed;
//   }
// `;

// const SignInButton = styled(Button)`
//   color: rgb(255, 168, 0);
//   background: transparent;
//   border: none;
// `;

// const StyledSignUpButton = styled.div`
//   background-color: #45b70c;
//   color: white;
//   border: none;
//   border-radius: 500px;
//   padding: 10px 24px;
//   font-size: 16px;
//   font-weight: 700;
//   letter-spacing: 1px;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   white-space: nowrap;
// `;

// const CloseButtonNew = styled.div`
//   position: absolute;
//   top: 10px;
//   right: 10px;
//   font-size: 18px;
//   display: none;

//   @media (max-width: 640px) {
//     display: block;
//   }
// `;

// class CustomeReg extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isLogged: storage.getKey("logged"),
//       show: this.props.show ? this.props.show : false,
//       phone: "",
//       username: "",
//       email: "",
//       password: "",
//       confirmPassword: "",
//       referral: this.props.referral || "",
//       ruleChecked: false,
//       ruleChecked18: false,
//       submitted: false,
//       disabled: false,
//       effect: "zoomIn",
//     };
//   }

//   componentDidMount() {
//     socket.on(C.REGISTER_USER, (data) => this.setRegister(decode(data)));
//     Event.on("register_form", () => {
//       this.handleShow();
//     });
//   }

//   setRegister = (data) => {
//     console.log(data);
//     if (data.error) {
//       this.setState({ disabled: false, submitted: false });
//       return sendNotfication(data.error, "success", "bottom-left");
//     }

//     if (data.status) {
//       console.log("datataaaa", data);
//       this.setState({ submitted: false });
//       wait(1000).then(() => {
//         socket.emit(
//           C.LOGIN_USER,
//           encode({
//             username: data.name,
//             password: data.password,
//             recaptcha: "google",
//           })
//         );
//       });
//     }
//   };

//   handleShow = () => {
//     this.setState({ show: true, effect: "zoomIn" });
//   };

//   handleClose = () => {
//     this.setState({
//       show: false,
//       effect: "zoomOut",
//       disabled: false,
//       submitted: false,
//       ruleChecked: false,
//       ruleChecked18: false,
//     });
//   };

//   verifyRefrelCode = async () => {
//     try {
//       const response = await axios.get(
//         `https://api.betbazaar365.com/verify-referral-code/${this.state.referral}`
//       );
//       console.log("response comes like", response);

//       return response?.data?.valid;
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   handleSubmit = async (e) => {
//     var verified;
//     e.preventDefault();
//     this.setState({ submitted: true, disabled: true });

//     const {
//       username,
//       email,
//       phone,
//       password,
//       confirmPassword,
//       ruleChecked,
//       referral,
//       ruleChecked18,
//     } = this.state;

//     if (!phone) {
//       sendNotfication("Please enter a phone number", "error", "bottom-left");
//       this.setState({ disabled: false });
//       return;
//     }

//     if (isNaN(phone)) {
//       sendNotfication(
//         "Please enter a valid phone number",
//         "error",
//         "bottom-left"
//       );
//       this.setState({ disabled: false });
//       return;
//     }

//     if (phone.length < 10 || phone.length > 15) {
//       sendNotfication(
//         "Please enter a valid phone number",
//         "error",
//         "bottom-left"
//       );
//       this.setState({ disabled: false });
//       return;
//     }

//     if (!username) {
//       sendNotfication("Please enter a username", "error", "bottom-left");
//       this.setState({ disabled: false });
//       return;
//     }
//     if (!password) {
//       sendNotfication("Please enter a password", "error", "bottom-left");
//       this.setState({ disabled: false });
//       return;
//     }

//     if (!confirmPassword) {
//       sendNotfication(
//         "Please enter a confirm password",
//         "error",
//         "bottom-left"
//       );
//       this.setState({ disabled: false });
//       return;
//     }
//     if (password !== confirmPassword) {
//       sendNotfication("Passwords do not match", "error", "bottom-left");
//       this.setState({ disabled: false });
//       return;
//     }
//     // if (!email) {
//     //     sendNotfication('Please enter an email', 'error', 'bottom-left');
//     //     this.setState({ disabled: false });
//     //     return;
//     // }
//     if (!ruleChecked18) {
//       sendNotfication(
//         "You must be at least 18 years old to continue",
//         "error",
//         "bottom-left"
//       );
//       this.setState({ disabled: false });
//       return;
//     }
//     if (!ruleChecked) {
//       sendNotfication(
//         "Please agree to the terms and conditions",
//         "error",
//         "bottom-left"
//       );
//       this.setState({ disabled: false });
//       return;
//     }

//     if (username.length < 5) {
//       this.setState({ disabled: false });
//       sendNotfication(
//         "Please enter username more than 5 words",
//         "success",
//         "bottom-left"
//       );
//       return;
//     }

//     // if (!isEmail(email)) {
//     //     this.setState({ disabled: false });
//     //     sendNotfication('Please enter valid email address', 'success', 'bottom-left');
//     //     return;
//     // }

//     if (referral && referral.trim() !== "") {
//       console.log(referral);
//       let verified = await this.verifyRefrelCode();
//       if (!verified) {
//         console.log("inside false");
//         this.setState({ disabled: false });
//         sendNotfication(
//           "Please enter a valid referral code",
//           "error",
//           "bottom-left"
//         );
//         return;
//       }
//     }

//     socket.emit(
//       C.REGISTER_USER,
//       encode({
//         phone: phone,
//         username: username,
//         password: password,
//         email: email || "dummyemail@gmail.com",
//         method: true,
//         refree: referral || "",
//         aff: storage.getKey("aff") ? storage.getKey("aff") : null,
//       })
//     );
//     this.handleClose();
//   };

//   handleInputChange = (e) => {
//     this.setState({ [e.target.name]: e.target.value });
//   };

//   checkRule = () => {
//     this.setState((prevState) => ({ ruleChecked: !prevState.ruleChecked }));
//   };
//   checkRule18 = () => {
//     this.setState((prevState) => ({ ruleChecked18: !prevState.ruleChecked18 }));
//   };

//   login = () => {
//     this.handleClose();
//     Event.emit("login_form");
//   };

//   render() {
//     const {
//       show,
//       username,
//       email,
//       phone,
//       password,
//       confirmPassword,
//       ruleChecked,
//       disabled,
//       referral,
//       ruleChecked18,
//     } = this.state;

//     return (
//       <>
//         {storage.getKey("logged") ? (
//           false
//         ) : (
//           <p
//             onClick={this.handleShow}
//             className=""
//             style={{
//               textShadow: "2px 2px rgb(255, 168, 0)",
//               marginTop: "10px",
//             }}
//           >
//             Claim My Bonus Now
//           </p>
//         )}

//         <StyledModal
//           size="md"
//           centered
//           show={storage.getKey("logged") ? false : show}
//           onHide={this.handleClose}
//           aria-labelledby="register-modal"
//           className={`animated ${this.state.effect}`}
//         >
//           <div className="login-main">
//             <div className="login-left">
//               <img
//                 className="login-top-img"
//                 src="\assets\bcimages\login\signup.png"
//               />
//               <img
//                 className="login-top-img-2"
//                 src="\assets\bcimages\login\login-banner-2.webp"
//               />
//               <img
//                 className="login-logo-img"
//                 src="\assets\bcimages\assamgames.png"
//               />
//               <CloseButtonNew onClick={this.handleClose}>×</CloseButtonNew>
//               <div className="login-content">
//                 <p className="login-content-title">Stay Untamed</p>
//                 <p className="login-content-desc">
//                   Sign Up & Get Welcome Bonus
//                 </p>
//               </div>
//             </div>

//             <div className="login-right">
//               <ModalHeader>
//                 <p className="signin-text-header">Sign up</p>
//                 <CloseButton onClick={this.handleClose}>×</CloseButton>
//               </ModalHeader>
//               <ModalBody>
//                 <StyledForm onSubmit={this.handleSubmit}>
//                   <StyledInput
//                     type="text"
//                     name="phone"
//                     value={phone}
//                     onChange={this.handleInputChange}
//                     placeholder="Phone Number"
//                   />

//                   <StyledInput
//                     type="text"
//                     name="username"
//                     value={username}
//                     onChange={this.handleInputChange}
//                     placeholder="Username"
//                   />

//                   <StyledInput
//                     type="email"
//                     name="email"
//                     value={email}
//                     onChange={this.handleInputChange}
//                     placeholder="Email Address (optional)"
//                   />

//                   <StyledInput
//                     type="password"
//                     name="password"
//                     value={password}
//                     onChange={this.handleInputChange}
//                     placeholder="Password"
//                   />

//                   <StyledInput
//                     type="password"
//                     name="confirmPassword"
//                     value={confirmPassword}
//                     onChange={this.handleInputChange}
//                     placeholder="Confirm Password"
//                   />

//                   <StyledInput
//                     name="referral"
//                     value={referral}
//                     onChange={this.handleInputChange}
//                     placeholder="Referral Code (optional)"
//                   />

//                   <div>
//                     <input
//                       type="checkbox"
//                       id="ruleCheck"
//                       checked={ruleChecked18}
//                       onChange={this.checkRule18}
//                     />
//                     <label
//                       className="checkbox-signup"
//                       htmlFor="ruleCheck"
//                       style={{ marginLeft: "10px" }}
//                     >
//                       I agree & confirm I am at least 18 years old
//                     </label>
//                   </div>
//                   <div>
//                     <input
//                       type="checkbox"
//                       id="ruleCheck"
//                       checked={ruleChecked}
//                       onChange={this.checkRule}
//                     />
//                     <label
//                       className="checkbox-signup"
//                       htmlFor="ruleCheck"
//                       style={{ marginLeft: "10px" }}
//                     >
//                       I agree with the user agreement
//                     </label>
//                   </div>
//                   <ButtonContainer>
//                     <SignUpButton type="submit" disabled={disabled}>
//                       {disabled && (
//                         <span
//                           className="spinner-grow spinner-grow-sm mr-1"
//                           role="status"
//                           aria-hidden="true"
//                         ></span>
//                       )}
//                       Sign Up
//                     </SignUpButton>
//                   </ButtonContainer>
//                   <div className="signup-button">
//                     Already have an account?
//                     <SignInButton onClick={this.login}>Sign In</SignInButton>
//                   </div>
//                 </StyledForm>
//               </ModalBody>
//             </div>
//           </div>
//         </StyledModal>
//       </>
//     );
//   }
// }

// export default CustomeReg;
import React from "react";

function CustomeReg() {
  return <div>Sign UP</div>;
}

export default CustomeReg;
